module.exports = __webpack_public_path__ + "img/boy_def1.c735c4f8.png";